import type { TimeRangeConfig } from '@/api/generated/model';

/**
 * React Query cache defaults for Nebuly system pages.
 *
 * Aggregates are keyed by project + time range and change slowly, so a longer stale
 * window avoids redundant refetches when switching between sub-pages in the same session.
 */
export const NEBULY_PAGE_QUERY_OPTIONS = {
  staleTime: 5 * 60_000,
  cacheTime: 30 * 60_000,
  refetchOnWindowFocus: false,
  refetchOnMount: false,
} as const;

/** Stable query-key fragment for a resolved page time range. */
export function getPageTimeRangeQueryKey(timeRange: TimeRangeConfig | undefined): string | null {
  if (!timeRange) return null;
  return `${timeRange.kind}|${timeRange.start}|${timeRange.end}|${timeRange.timezone ?? ''}|${timeRange.recompute ?? ''}`;
}
